import { render, staticRenderFns } from "./productDocuments.vue?vue&type=template&id=6e1c1a80&scoped=true&"
import script from "./productDocuments.vue?vue&type=script&lang=js&"
export * from "./productDocuments.vue?vue&type=script&lang=js&"
import style0 from "./productDocuments.vue?vue&type=style&index=0&id=6e1c1a80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1c1a80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e1c1a80')) {
      api.createRecord('6e1c1a80', component.options)
    } else {
      api.reload('6e1c1a80', component.options)
    }
    module.hot.accept("./productDocuments.vue?vue&type=template&id=6e1c1a80&scoped=true&", function () {
      api.rerender('6e1c1a80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/documents/productDocuments.vue"
export default component.exports